// extracted by mini-css-extract-plugin
module.exports = {"loadingMask":"Loading_loadingMask__v_W3B","turn_around":"Loading_turn_around__nIKN8"};